<template>
  <HomeBan />
  <pd4Home />
  <IndexProfile />
  <indexNews />
</template>

<script>
import HomeBan from './HomeBan.vue';
import pd4Home from './IndexTechnology.vue';
import IndexProfile from './IndexProfile.vue';
import indexNews from './IndexNew.vue';
import { useHead } from '@vueuse/head';
export default {
  name: 'vueIndex',
  components: {
    HomeBan,
    pd4Home,
    IndexProfile,
    indexNews,
  },
  setup() {
    useHead(
      {
        meta: [
          {
            name: 'baidu-site-verification',
            content: 'codeva-ilmL7l051h'
          },
          {
            name: 'description',
            content: '天津偶联生物医药技术有限公司依托于驻津头部科研院的技术团队创立。初期致力于纳米医学的基础研究。近年来，国家鼓励基础领域科技创新，本司面向全国医疗健康事业，积极推动临床医学-分子生物学-纳米医学-转化医学相结合的多学科交叉系统性研究。'
          },
          {
            name: 'keywords',
            content: '天津偶联,偶联生物,天津偶联生物,医药技术,物质合成,纳米组装,生物医学成像,多模式疾病干预与病理学分析,高端物质结构解析'
          },
        ],
        title: '天津偶联生物医药技术有限公司'
      })
  }
};
</script>

<style scoped>
</style>